<template>
    <div class="energy-consumption">
        <div class="search_wrap">
            <el-form
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="true"
                :model="searchForm"
            >
                <el-form-item label="时间" style="float: left">
                    <el-date-picker
                        v-model="searchForm.time"
                        type="month"
                        placeholder="选择日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                    ></el-date-picker>
                    <el-button
                        type="primary"
                        size="small"
                        style="margin-left: 40px"
                        @click="search"
                        >查询</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="consumption-container">
            <div class="consump-echarts">
                <v-chart
                    :auto-resize="true"
                    :options="energyConsumpBar"
                    ref="energyConsumpBar"
                    theme="ovilia-green"
                    @click="consumpClick"
                />
            </div>
        </div>
        <div class="treeMap-container">
            <div class="treeMap-echarts">
                <v-chart
                    :auto-resize="true"
                    :options="treeMap"
                    ref="treeMap"
                    theme="ovilia-green"
                />
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/treemap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import echarts from "echarts";
import utils from "@/utils/utils";

export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            searchForm: {
                time: ""
            },
            x_list: [],
            y_list: [],
            selectMonth: "",
            treeMaps: [],
            treeMapColors: []
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        search() {
            this.getEnergyList(this.searchForm.time);
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate3;
                    this.selectMonth = this.searchForm.time;
                    this.getEnergyList(this.searchForm.time);
                    this.getAmountByMonth(this.selectMonth);
                }
            });
        },
        getEnergyList(time) {
            api.getEnergyList({ show_time: time }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.months;
                    this.y_list = res.bus_json.amountList;
                }
            });
        },
        getAmountByMonth(month) {
            api.getAmountByMonth({ show_time: month }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeMaps = res.bus_json;
                    this.treeMapColors = [];
                    this.treeMaps.forEach(item => {
                        this.treeMapColors.push(item.color);
                    });
                }
            });
        },
        consumpClick(params) {
            this.selectMonth = params.name;
            this.getAmountByMonth(this.selectMonth);
        }
    },
    computed: {
        energyConsumpBar() {
            const option = {
                title: {
                    text: "外购电力间接碳排放量",
                    left: "50%",
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function(params) {
                        var tar = params[0];
                        // return "综合能耗:"+tar.data.value+"元";
                        return (
                            tar.axisValue +
                            "<br/>" +
                            "碳排放：" +
                            tar.data +
                            "吨"
                        );
                    }
                },
                // legend: {
                //     data: ["综合能耗"],
                //     textStyle: { fontSize: 12, color: "#fff" }
                // },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            fontSize: 14,
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        xAxisLeft: "#666",
                        // data: this.x_list
                        data: this.x_list
                    }
                ],
                yAxis: [
                    {
                        name: "吨",
                        type: "value",
                        yAxisTop: "yellow",
                        nameTextStyle: {
                            color: "white",
                            padding: 10,
                            fontSize: 14
                        },
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        },
                        // splitLine: {
                        //     show: true,
                        //     lineStyle: {
                        //         // type:'dashed',
                        //         color: ['#666666'],
                        //     },
                        // },
                        xAxisLeft: "#666666"
                    }
                ],
                series: [
                    {
                        name: "碳排放",
                        type: "bar",
                        itemStyle: {
                            normal: {
                                color: "#409eff" // 柱子颜色
                            }
                        },
                        // barWidth: 50,
                        data: this.y_list
                    }
                ]
            };
            return option;
        },
        treeMap() {
            var formatUtil = echarts.format;
            const option = {
                title: {
                    text: `${this.selectMonth}碳排放构成`,
                    left: "center",
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                grid: {
                    left: "0%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true
                },
                tooltip: {
                    formatter: function(info) {
                        var value = info.value;
                        var treePathInfo = info.treePathInfo;
                        var treePath = [];

                        for (var i = 1; i < treePathInfo.length; i++) {
                            treePath.push(treePathInfo[i].name);
                        }

                        return [
                            '<div class="tooltip-title">' +
                                formatUtil.encodeHTML(treePath.join("/")) +
                                "</div>",
                            "碳排放: " + formatUtil.addCommas(value) + "吨"
                        ].join("");
                    }
                },
                // legend: {
                //     data: ["碳排放"],
                //     textStyle: { fontSize: 12, color: utils.getFontColor() }
                // },
                series: [
                    {
                        name: "碳排放构成",
                        type: "treemap",
                        visibleMin: 300,
                        label: {
                            show: true,
                            // formatter: "{a}/{b}/{c}"
                            fontSize: "16",
                            formatter: function(info) {
                                var treePathInfo = info.treePathInfo;
                                var treePath = [];

                                for (var i = 1; i < treePathInfo.length; i++) {
                                    treePath.push(
                                        treePathInfo[i].name +
                                            "\n\n" +
                                            "碳排放：" +
                                            treePathInfo[i].value +
                                            "吨"
                                    );
                                }
                                return treePath.join("\n\n");
                            },
                            color: "#fff"
                        },
                        itemStyle: {
                            borderColor: "#446595",
                            gapWidth: 0.5,
                            borderWidth: 0.5
                        },
                        colorMappingBy: "index",
                        breadcrumb: {
                            show: true
                        },
                        // levels: [
                        //     {
                        //         itemStyle: {
                        //             borderWidth: 1,
                        //             gapWidth: 1
                        //         }
                        //     },
                        //     {
                        //         itemStyle: {
                        //             gapWidth: 1
                        //         }
                        //     },
                        //     {
                        //         colorSaturation: [0.35, 0.5],
                        //         itemStyle: {
                        //             gapWidth: 1,
                        //             borderColorSaturation: 0.6
                        //         }
                        //     }
                        // ],
                        data: this.treeMaps
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.energy-consumption {
    // box-sizing: border-box;
    padding: 0 px2Rem(20px) px2Rem(10px) px2Rem(20px);
    // background: transparent;
    width: 100%;
    height: 100%;
    overflow: auto;

    .search_wrap {
        margin-top: px2Rem(20px);
        margin-bottom: px2Rem(30px);
        margin-left: px2Rem(20px);
        width: 100%;

        .time_btn {
            background: #29b85e;
            /*color: #409eff;*/
            color: #fff;
        }
    }

    .consumption-container {
        width: 98%;
        height: px2Rem(350px);
        /*background: url(../../../../assets/image/leaderpage/kuai.png) no-repeat;*/
        /*color: #409eff;*/
        color: #fff;
        background-size: 100% 100%;
        margin: px2Rem(80px) auto px2Rem(20px) auto;

        .consump-echarts {
            width: 96%;
            height: 85%;
            // margin: px2Rem(20px) auto 0 auto;
            clear: both;

            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }

    .treeMap-container {
        width: 98%;
        height: px2Rem(400px);
        margin: px2Rem(20px) auto px2Rem(20px) auto;
        /*background: url(../../../../assets/image/leaderpage/kuai.png) no-repeat;*/
        color: #409eff;
        background-size: 100% 100%;

        .treeMap-echarts {
            width: 96%;
            height: 100%;
            margin: px2Rem(20px) auto 0 auto;
            clear: both;

            .echarts {
                width: 100%;
                height: 85%;
            }
        }
    }

    .con-title {
        font-size: 14px;
        text-indent: 1em;
        line-height: px2Rem(36px);
        /*color: #409eff;*/
        color: #fff;
    }
}
</style>
